<template>
    <div class="hide_scroll" style="padding: 0 12px; display: flex; overflow-x: scroll; gap: 15px;">
        <div @click="showTrainingRequestDetail(each)" v-for="each, i in groundList" :key="i" style="height: 200px; position: relative; flex-shrink: 0; display: flex; flex-direction: column; overflow: hidden; background-color: #808080; justify-content: end; width: 155px; border-radius: 12px;">
            <div v-if="each.thumbnail_path1" style="position: absolute; top: 0; width: 100%; height: 100%; left: 0; z-index: 10; border-radius: 12px; overflow: hidden;">
                <img style="width: 100%; height: 100%; object-fit: cover;" :src="$resourcePath + each.thumbnail_path1" alt="">
            </div>
            <div :style="{background: each.thumbnail_path1 ? '#00000080' : ''}" style="display: flex; flex-direction: column; color: #fff; position: relative; z-index: 20; flex: 1; padding: 12px;">
                <div style="flex: 1;">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <div>
                            <ProfileImage :imagePath="each.image_path" style="width: 35px;"></ProfileImage>
                        </div>
                        <div>
                            <div style="font-weight: 700; font-size: 12px; ">{{ each.nic_name }} <span style="font-weight: 900; margin-left: 2px; color: var(--color-main);">{{ each.position }}</span></div>
                            <div style="font-size: 12px; color: #c6c6c6; line-height: 16px; margin-top: 4px;">{{ each.insert_date | agoDateStr }}</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="ellipsis" style="font-size: 12px; line-height: 21px; font-weight: 700;">{{ each.contents }}</div>
                    <div style="display: flex; gap: 10px; align-items: center; margin-top: 7px;">
                        <div style="display: flex; gap: 5px; align-items: center;">
                            <img style="width: 11px;" :src="require('@/assets/img/like_white.png')" alt="">
                            <div style="font-weight: 700; font-size: 12px; color: #fff;">{{ each.like_number }}</div>
                        </div>
                        <div style="display: flex; gap: 5px; align-items: center;">
                            <img style="width: 12px; margin-top: 2px;" :src="require('@/assets/img/reply_white.png')" alt="">
                            <div style="font-weight: 700; font-size: 12px; color: #fff;">{{ each.reply_number }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import { MAIN_TYPE } from '@/Constants';

export default {
    name: 'GroundNews',
    components: { ProfileImage },
    props: {
        groundList: {
            type: Array,
            default: () => {}
        }
    },
    methods: {
        showTrainingRequestDetail(teamDetail) {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: true, soccerhowIdx: teamDetail.idx, isPopular: false, isRealTime: false })
        }
    }
}
</script>

<style scoped>
.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical
}
</style>